/** "38 rules" / "1 rule" — English plural with the simple +s rule. */
export const pluralize = (count: number, noun: string): string =>
  `${count} ${noun}${count === 1 ? '' : 's'}`;
